import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { LabelsBlock } from '../../commonComponents/CommonComponents'
import { DmcGrid } from '../../../common/DmcGrid'
import { DmcText } from '../../../common/DmcText'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function FamousMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const detectedPersonId = messageDetails.personId // This is not the famous person
  const contributorId = messageDetails.contributorId

  const detectedPersonSummary = queueCachesState.personsCache[detectedPersonId]
  const detectedPersonLabels = queueCachesState.labelsCache[detectedPersonId]
  const userSummary = queueCachesState.usersCache[contributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(detectedPersonId)
    queueCachesActions.fetchPersonLabels(detectedPersonId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (
    isNullOrUndefined(detectedPersonSummary) ||
    isNullOrUndefined(detectedPersonLabels) ||
    isNullOrUndefined(userSummary)
  ) {
    return null
  }

  const rows = []
  rows.push({
    label: t('name', 'Name'),
    detectedPerson: detectedPersonSummary?.summary?.name,
    famousPerson: messageDetails?.name,
  })
  rows.push({
    label: t('birthPlace', 'Birth Place'),
    detectedPerson: detectedPersonSummary?.birth?.value?.place?.original,
    famousPerson: messageDetails?.birthPlace,
  })
  rows.push({
    label: t('birthDate', 'Birth Date'),
    detectedPerson: detectedPersonSummary?.birth?.value?.date?.original,
    famousPerson: messageDetails?.birthDate,
  })
  rows.push({
    label: t('deathPlace', 'Death Place'),
    detectedPerson: detectedPersonSummary?.death?.value?.place?.original,
    famousPerson: messageDetails?.deathPlace,
  })
  rows.push({
    label: t('deathDate', 'Death Date'),
    detectedPerson: detectedPersonSummary?.death?.value?.date?.original,
    famousPerson: messageDetails?.deathDate,
  })
  rows.push({
    label: t('parent1', 'Parent 1'),
    detectedPerson: '',
    famousPerson: messageDetails?.parent1Name,
  })
  rows.push({
    label: t('parent2', 'Parent 2'),
    detectedPerson: '',
    famousPerson: messageDetails?.parent2Name,
  })
  rows.push({
    label: t('spouse', 'Spouse'),
    detectedPerson: '',
    famousPerson: messageDetails?.spouseName,
  })
  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('detectedPerson', 'Detected Person')}
          data={
            <>
              <PersonLink personId={detectedPersonId} personName={detectedPersonSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={detectedPersonId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>

      <TreeIdCells
        treeId={messageDetails?.treeId || detectedPersonSummary?.summary?.treeId}
        isResearcherTree={messageDetails?.researcherTree || detectedPersonSummary?.summary?.researcherTree}
      />

      {/* Row */}
      <Cell columns={12}>
        <DmcGrid columns={[2, 5, 5]}>
          <DataBlock heading="" data="" />
          <DataBlock heading={t('queues.famousPerson', 'Famous Person')} data="" />
          <DataBlock heading={t('detectedPerson', 'Detected Person')} data="" />
          {rows?.map((row) => {
            return (
              <React.Fragment key={`${row.label}${row.famousPerson}${row.detectedPerson}`}>
                <DataBlock heading={row.label} data="" />
                <DmcText text={row.famousPerson} />
                <DmcText text={row.detectedPerson} />
              </React.Fragment>
            )
          })}
        </DmcGrid>
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DataBlock heading={t('queues.famousType', 'Famous Type')} data={messageDetails?.famousType} />
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DataBlock heading={t('biography', 'Biography')} data={messageDetails?.biography} />
      </Cell>

      {/* Row */}
      <LabelsBlock personLabels={detectedPersonLabels} />
    </Grid>
  )
}
